import React from "react";
import {KeyboardEventUtil} from "../../utils/KeyboardEventUtil";

type MultiLineTextEditorProps = {
    value: string;
    isEdit: boolean;
    onClick?: React.MouseEventHandler<HTMLSpanElement>;
    onEditEnd?: (value: string, isCancel: boolean) => void;
}

export const MultiLineTextEditor = (props: MultiLineTextEditorProps) => {

    const [value, setValue] = React.useState(props.value);
    const [inComposition, setInComposition] = React.useState(false);
    const ref = React.useRef<HTMLTextAreaElement>(null);

    React.useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
        if (props.isEdit && ref.current) {
            ref.current.focus();
            ref.current.selectionStart = ref.current.selectionEnd = value.length; // 文末を選択
        }
    }, [props.isEdit]);

    function endEdit(isCancel: boolean) {
        props.onEditEnd?.(value, isCancel);
    }

    const handleKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement> = (e) => {
        e.stopPropagation();

        if (inComposition) {
            return;
        }

        if (KeyboardEventUtil.isLineBreakKey(e.nativeEvent)) {
            if (ref.current) {

                const new_value = value.substring(0, ref.current.selectionStart)
                    + "\n"
                    + value.substring(ref.current.selectionEnd);
                const new_selection_pos = ref.current.selectionStart + 1;

                setValue(new_value);
                setTimeout(() => {
                    if (ref.current) {
                        // adjust caret
                        ref.current.selectionStart = ref.current.selectionEnd = new_selection_pos;
                    }
                }, 0)
                return;
            }
        }

        if (e.code === 'Escape') {
            endEdit(true);

        } else if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            endEdit(false);
        }
    }

    if (props.isEdit) {
        return <textarea
            ref={ref}
            value={value}
            rows={value.split("\n").length}
            onKeyDown={handleKeyDown}
            onCompositionStart={() => setInComposition(true)}
            onCompositionEnd={() => setInComposition(false)}
            onChange={(e) => setValue(e.target.value)}
            onBlur={() => endEdit(false)}
        />;
    } else {
        return <span onClick={props.onClick}>{props.value}</span>;
    }
}
